import {
    Avatar,
    Box,
    Button,
    Card, CardBody,
    Divider,
    Flex, IconButton,
    Image, Input,
    Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay,
    Skeleton,
    SkeletonCircle,
    Stack,
    Text,
    Textarea,
    useDisclosure,
    useToast
} from "@chakra-ui/react";
import { BrandButton, GhostButton } from "../../components/TablePageShell";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { RelationShip } from "../../interfaes/student";
import { Roles } from "../../interfaes/user";
import { IEP } from "../../interfaes/iep";
import { GiRollingEnergy, GiStairsGoal } from 'react-icons/gi';
import { GoChecklist } from 'react-icons/go';
import { MdAdd, MdArrowBack, MdBuild, MdDelete, MdRateReview } from 'react-icons/md';
import { AiOutlineFileDone } from 'react-icons/ai';
import { addDailyLog, completeIEP, deleteLog, onGetLogs, onGetSingleIEP, updateDailyLog } from "../../http/iepAPis";
import CoustomAlertDialog from "../../components/CoustomAlertDialog";
import { IoMdDoneAll } from "react-icons/io";
import { GrEdit } from "react-icons/gr";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";


export default function IepPage() {
    const { t } = useTranslation('iep');
    const { state } = useLocation();
    const navigate = useNavigate();
    const toast = useToast()
    const { isOpen, onOpen, onClose } = useDisclosure();


    const [loading, setLoading] = useState(true);
    const [managingLog, setManagingLog] = useState(false);
    const [loadingIEPCOMPLETE, setLoadingIEPCOMPLETE] = useState(false);
    const { isOpen: isOpenLog, onOpen: onOpenLog, onClose: onCloseLog } = useDisclosure();


    const [date, setDate] = useState<string>('');

    const { iepId } = useParams();

    const onCompleteIEP = async () => {
        if (logToEdit) {
            try {
                setLoadingIEPCOMPLETE(true);
                await deleteLog(logToEdit.id);
                toast({
                    title: 'Log Deleted',
                    description: "Log Deleted Successfully",
                    status: 'success',
                    duration: 3000,
                    isClosable: true,
                })
                setLogToEdit(undefined);
                onClose();
                onGetLog();
            } catch (e) {
                console.log(e);
                toast({
                    title: 'Failed',
                    description: "Could not add log at the moment.",
                    status: 'success',
                    duration: 3000,
                    isClosable: true,
                })
            } finally {
                setLoadingIEPCOMPLETE(false);
            }
        } else {
            try {
                if (iepId) {
                    setLoadingIEPCOMPLETE(true);
                    await completeIEP(iepId);
                    toast({
                        title: 'IEP Completed',
                        description: "IEP Completed Successfully",
                        status: 'success',
                        duration: 3000,
                        isClosable: true,
                    })
                    onClose();
                    navigate(-1);
                }
            } catch (e) {
                console.log(e);
                toast({
                    title: 'IEP Failed',
                    description: "Could not complete IEP at the moment.",
                    status: 'success',
                    duration: 3000,
                    isClosable: true,
                })
            } finally {
                setLoadingIEPCOMPLETE(false)
            }
        }
    }


    const [iepFormAPI, setIEPFormAPI] = useState<IEP>();
    const [log, setLog] = useState<string>('');
    const [time, setTime] = useState<string>('');
    const [logToEdit, setLogToEdit] = useState<any>(undefined);
    const [logObj, setLogObj] = useState<any>();

    const getIEP = async () => {
        if (iepId) {
            try {
                // Try to get studentId from state, if not available we might need to fetch it or the API might handle it if we only pass iepId
                // Looking at onGetSingleIEP it seems it requires studentId.
                const studentId = state?.student?.studentId;
                if (studentId) {
                    const response = await onGetSingleIEP(studentId, iepId);
                    setIEPFormAPI(response.data);
                } else {
                    // If student info is missing in state, we might need a way to fetch IEP by ID only or find student ID first.
                    // For now, let's just log and set loading false.
                    console.error("Student ID missing in state");
                }
            } catch (e) {
                console.log(e);
            }
            setLoading(false)
        }
    }
    useEffect(() => {
        setLoading(true)
        onGetLog();
        getIEP();
    }, [state, iepId]);

    useEffect(() => {
        const handleBackNavigation = () => {
            getIEP();
        };

        // Listen for the popstate event
        window.addEventListener('popstate', handleBackNavigation);

        // Cleanup the event listener when the component unmounts
        return () => {
            window.removeEventListener('popstate', handleBackNavigation);
        };
    }, []);

    const handleLog = async () => {
        try {
            if (iepId) {
                setManagingLog(true);
                if (logToEdit) {
                    await updateDailyLog(iepId, log, logToEdit.id, date, time);
                } else {
                    await addDailyLog(iepId, log, date, time);
                }

                onGetLog();
                setLog('');
                setTime('');
                setDate('');
            }
        } catch (e) {
            console.log(e)
        } finally {
            setManagingLog(false);
            setLogToEdit(undefined);
            onCloseLog();
        }
    }

    const onGetLog = async () => {
        try {
            if (iepId) {
                setManagingLog(true);
                const response = await onGetLogs(iepId);
                setLogObj(response.data.content);
            }
        } catch (e) {
            console.log(e);
        } finally {
            setManagingLog(false);
        }
    }

    const materialColors = [
        '#2196F3', '#4CAF50', '#FFC107', '#E91E63', '#9C27B0',
        '#FF9800', '#795548', '#00BCD4', '#8BC34A', '#FF5722'
    ];

    // Helper component for modernized step cards
    const StepCard = ({ step, title, icon: Icon, onClick, isCompleted }: { step: number, title: string, icon: any, onClick: () => void, isCompleted: boolean }) => (
        <Card
            p={'20px'}
            borderRadius='xl'
            boxShadow='sm'
            transition='all 0.2s'
            cursor='pointer'
            _hover={{
                transform: 'translateY(-4px)',
                boxShadow: 'md',
                bg: 'gray.50'
            }}
            bg={isCompleted ? 'green.50' : 'white'}
            border='1px solid'
            borderColor={isCompleted ? 'green.100' : 'gray.100'}
            onClick={onClick}
        >
            <Flex direction='column' height='100%' justifyContent='space-between'>
                <Flex justifyContent='space-between' alignItems='start'>
                    <Box
                        p='10px'
                        borderRadius='lg'
                        bg={isCompleted ? 'green.100' : 'blue.50'}
                        color={isCompleted ? 'green.600' : 'blue.600'}
                    >
                        <Icon size='24px' />
                    </Box>
                    {isCompleted && <IoMdDoneAll color='#2F855A' size='20px' />}
                </Flex>
                <Box mt='4'>
                    <Text fontWeight='700' fontSize='sm' color='gray.500' textTransform='uppercase' letterSpacing='wider'>
                        {t(`step${step}`)}
                    </Text>
                    <Text fontWeight='800' fontSize='md' noOfLines={2} title={title}>
                        {title}
                    </Text>
                </Box>
            </Flex>
        </Card>
    );

    // @ts-ignore
    const iep: IEP = iepFormAPI;
    const student = state?.student || iep?.student;

    if (student && !loading) {
        const parent = student.relationships?.filter((r: RelationShip) => r.relation === Roles.PARENT);

        return (<Box p={6}>
            <Flex mb={6} justify="space-between" align="center">
                <Text fontSize="2xl" fontWeight="900" color="gray.800">
                    {t('iep')} : {iep?.year}
                </Text>
                <GhostButton leftIcon={<MdArrowBack />} onClick={() => navigate(`/students/${student.studentId}`, { state: student })}>
                    Back
                </GhostButton>
            </Flex>
            <Card bg="white" border="1px solid #e8e4de" borderRadius="16px" boxShadow="0 1px 4px rgba(0,0,0,0.07), 0 0 0 1px rgba(0,0,0,0.04)" p={6}>
                <Flex>
                    <Box display={{ base: 'none', md: 'block' }} w="60px" h="60px" flexShrink={0}>
                        <Avatar
                            borderRadius='full'
                            w="100%"
                            h="100%"
                            name={student?.fullName}
                            src={state?.studentImage || student?.studentImage}
                        />
                    </Box>
                    <Box w={"2%"} />
                    <Box w={"78%"}>
                        <Text fontWeight={'900'} fontSize={'24px'}>
                            {student?.fullName}
                        </Text>
                        <Text fontWeight={'500'} fontSize={'18px'} color={'gray.500'}>
                            {`${t('address')} : ${student?.province || ''} | ${student?.district || ''} | ${student?.localLevel || ''} | ${student?.localAddress || ''}`}
                        </Text>
                        {parent && parent.length > 0 && (<Text fontWeight={'500'} fontSize={'18px'} color={'gray.500'}>
                            {`${t('parentInformation')} : ${parent[0]?.relatedUser?.displayName || ''} | ${t('relation')} : ${parent[0]?.relation || ''} | ${t('contact')} : ${parent[0]?.relatedUser?.phone || ''}`}
                        </Text>)}
                        <Text fontWeight={'500'} fontSize={'18px'} color={'gray.500'}>
                            {`${t('level')} : ${iep?.level || ''} | ${t('section')} : ${iep?.section || ''} | ${t('roll')} : ${iep?.roll || ''}`}
                        </Text>
                    </Box>
                </Flex>
                <Text fontSize="24px" fontWeight={900} mt={'12px'}>
                    {t('iepProcess')}
                </Text>
                <Box display='grid'
                    mt={'12px'}
                    gridTemplateColumns={{ base: '100%', sm: '49% 49%', md: '32% 32% 32%', lg: '24% 24% 24% 24%' }}
                    gridGap='16px'>

                    <StepCard
                        step={1}
                        title={t('stepTitle')}
                        icon={GiRollingEnergy}
                        isCompleted={iep?.completedSteps?.includes(1) || false}
                        onClick={() => navigate(`/iep/${iep.iepId}/step1`, { state: { student, iep } })}
                    />

                    <StepCard
                        step={2}
                        title={t('step2Title')}
                        icon={GoChecklist}
                        isCompleted={iep?.completedSteps?.includes(2) || false}
                        onClick={() => navigate(`/iep/${iep.iepId}/step2`, { state: { student, iep } })}
                    />

                    <StepCard
                        step={3}
                        title={t('step3Title')}
                        icon={GiStairsGoal}
                        isCompleted={iep?.completedSteps?.includes(3) || false}
                        onClick={() => navigate(`/iep/${iep.iepId}/step3`, { state: { student, iep } })}
                    />

                    <StepCard
                        step={4}
                        title={t('step4Title')}
                        icon={MdRateReview}
                        isCompleted={iep?.completedSteps?.includes(4) || false}
                        onClick={() => navigate(`/iep/${iep.iepId}/step4`, { state: { student, iep } })}
                    />

                    <StepCard
                        step={5}
                        title={t('step5Title')}
                        icon={MdRateReview}
                        isCompleted={iep?.completedSteps?.includes(5) || false}
                        onClick={() => navigate(`/iep/${iep.iepId}/step5`, { state: { student, iep } })}
                    />

                    <StepCard
                        step={6}
                        title={t('step6Title')}
                        icon={MdRateReview}
                        isCompleted={iep?.completedSteps?.includes(6) || false}
                        onClick={() => navigate(`/iep/${iep.iepId}/step6`, { state: { student, iep } })}
                    />

                    <StepCard
                        step={7}
                        title={t('step7Title')}
                        icon={AiOutlineFileDone}
                        isCompleted={iep?.completedSteps?.includes(7) || false}
                        onClick={() => navigate(`/iep/${iep.iepId}/step7`, { state: { student, iep } })}
                    />
                </Box>
            </Card>
            <Flex mt={'24px'} justifyContent={'flex-end'}>
                <BrandButton h="55px" px={8} onClick={() => {
                    if (iep.completedSteps?.length === 7) {
                        onOpen()
                    } else {
                        toast({
                            title: 'Complete All The Steps!',
                            description: "You need to complete all the steps to complete IEP.",
                            status: 'warning',
                            duration: 3000,
                            isClosable: true,
                        })
                    }
                }
                }>
                    {t('completeIEP')}
                </BrandButton>
            </Flex>
            <Divider mt={'24px'} mb={'24px'} borderColor="#e8e4de" />
            <Card bg="white" border="1px solid #e8e4de" borderRadius="16px" boxShadow="0 1px 4px rgba(0,0,0,0.07), 0 0 0 1px rgba(0,0,0,0.04)" p={6}>
                <Flex justifyContent="space-between" alignItems="center" mb={6}>
                    <Text fontSize="24px" fontWeight={900}>
                        Session Notes
                    </Text>
                    <BrandButton
                        leftIcon={<MdAdd />}
                        onClick={() => {
                            setLogToEdit(undefined);
                            setLog('');
                            setTime('');
                            setDate('');
                            onOpenLog();
                        }}
                    >
                        Add Note
                    </BrandButton>
                </Flex>

                <Stack spacing={4}>
                    {logObj && logObj.length > 0 ? (
                        logObj.map((e: any, index: number) => (
                            <Card
                                key={e.id}
                                variant="outline"
                                borderColor="gray.100"
                                borderRadius="xl"
                                _hover={{ shadow: 'md', borderColor: 'blue.100' }}
                                transition="all 0.2s"
                            >
                                <CardBody p={4}>
                                    <Flex justifyContent="space-between" align="center">
                                        <Flex align="center" gap={4} flex={1}>
                                            <Box
                                                p={3}
                                                bg="blue.50"
                                                borderRadius="lg"
                                                color="blue.600"
                                            >
                                                <AiOutlineFileDone size="20px" />
                                            </Box>
                                            <Box>
                                                <Text fontWeight="bold" fontSize="md" color="gray.800">
                                                    {e.remarks}
                                                </Text>
                                                <Flex gap={4} mt={1}>
                                                    <Text fontSize="xs" color="gray.500" display="flex" alignItems="center" gap={1}>
                                                        <strong>Date:</strong> {e.dateString}
                                                    </Text>
                                                    <Text fontSize="xs" color="gray.500" display="flex" alignItems="center" gap={1}>
                                                        <strong>Duration:</strong> {e.workHours} hours
                                                    </Text>
                                                </Flex>
                                            </Box>
                                        </Flex>
                                        <Flex gap={2}>
                                            <IconButton
                                                size="sm"
                                                variant="ghost"
                                                colorScheme="blue"
                                                aria-label="Edit Note"
                                                icon={<GrEdit />}
                                                onClick={() => {
                                                    setLogToEdit(e);
                                                    setLog(e.remarks);
                                                    setTime(e.workHours);
                                                    setDate(e.dateString);
                                                    onOpenLog();
                                                }}
                                            />
                                            <IconButton
                                                size="sm"
                                                variant="ghost"
                                                colorScheme="red"
                                                aria-label="Delete Note"
                                                icon={<MdDelete />}
                                                onClick={() => {
                                                    setLogToEdit(e);
                                                    onOpen();
                                                }}
                                            />
                                        </Flex>
                                    </Flex>
                                </CardBody>
                            </Card>
                        ))
                    ) : (
                        <Box textAlign="center" py={10} color="gray.400">
                            <Text>No session notes recorded yet.</Text>
                        </Box>
                    )}
                </Stack>
            </Card>

            {/* Log Entry Modal */}
            <Modal isOpen={isOpenLog} onClose={onCloseLog} size="xl" isCentered>
                <ModalOverlay backdropFilter="blur(4px)" />
                <ModalContent borderRadius="2xl">
                    <ModalHeader borderBottom="1px solid" borderColor="gray.100">
                        {logToEdit ? 'Edit Session Note' : 'Add New Session Note'}
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody py={6}>
                        <Stack spacing={4}>
                            <Box>
                                <Text fontSize="sm" fontWeight="bold" mb={2} color="gray.600">Session Date</Text>
                                <Box border="1px solid" borderColor="gray.200" borderRadius="md" p={1}>
                                    <NepaliDatePicker
                                        inputClassName="form-control"
                                        value={date}
                                        onChange={(value: string) => setDate(value)}
                                        options={{ calenderLocale: "en", valueLocale: "en" }}
                                    />
                                </Box>
                            </Box>
                            <Box>
                                <Text fontSize="sm" fontWeight="bold" mb={2} color="gray.600">Activity / Remarks</Text>
                                <Textarea
                                    value={log}
                                    onChange={(e) => setLog(e.target.value)}
                                    _disabled={{ background: 'gray.50', color: 'gray.800', opacity: 1, cursor: 'not-allowed' }}
                                    variant="filled"
                                    bg="gray.50"
                                    borderRadius="lg"
                                    minH="120px"
                                />
                            </Box>
                            <Box>
                                <Text fontSize="sm" fontWeight="bold" mb={2} color="gray.600">Duration (in Hours)</Text>
                                <Input
                                    type="number"
                                    value={time}
                                    onChange={(e) => setTime(e.target.value)}
                                    _disabled={{ background: 'gray.50', color: 'gray.800', opacity: 1, cursor: 'not-allowed' }}
                                    variant="filled"
                                    bg="gray.50"
                                    borderRadius="lg"
                                />
                            </Box>
                        </Stack>
                    </ModalBody>
                    <ModalFooter bg="gray.50" borderBottomRadius="2xl" borderTop="1px solid" borderColor="gray.100">
                        <GhostButton mr={3} onClick={onCloseLog}>
                            Cancel
                        </GhostButton>
                        <BrandButton
                            isLoading={managingLog}
                            isDisabled={!log || !date || !time}
                            onClick={handleLog}
                            px={8}
                        >
                            {logToEdit ? 'Update Note' : 'Save Note'}
                        </BrandButton>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            <CoustomAlertDialog
                onClose={() => {
                    setLogToEdit(undefined);
                    onClose();
                }}
                onOpen={onOpen}
                isOpen={isOpen}
                onMainAction={onCompleteIEP}
                loading={loadingIEPCOMPLETE}
                warning={logToEdit ? false : true}
            />
        </Box>)
    } else {
        return (
            <Box>
                <Skeleton height='30px' width={'60%'} />
                <Box p={"12px"} background={"#ffffff"} mt={"18px"} borderRadius={'12px'}>
                    <Flex>
                        <Box w={"10%"}>
                            <SkeletonCircle size='30' />
                        </Box>
                        <Box w={"2%"} />
                        <Box w={"78%"}>
                            <Skeleton height='20px' width={'60%'} />
                            <Skeleton height='20px' width={'40%'} />
                            <Skeleton height='20px' width={'20%'} />
                        </Box>
                    </Flex>
                    <Box display='grid'
                        mt={'12px'}
                        gridTemplateColumns={'24% 24% 24% 24%'}
                        gridGap='14px'>
                        {[1, 2, 3, 4, 5, 6, 7].map(() =>
                            <Skeleton height='100px' />
                        )}

                    </Box>
                </Box>
            </Box>);
    }
}
